import { useState, useCallback } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../GlobalContext";

export default function useSettlement() {
  const { api } = useGlobalContext();

  const [volunteerSettlements, setVolunteerSettlements] = useState([]);
  const [volunteerSettlementDetails, setVolunteerSettlementDetails] =
    useState(null);
  const [volunteerSettlementLoading, setVolunteerSettlementLoading] =
    useState(false);

  const fetchVolunteerSettlementAmount = useCallback(
    async (payload = {}, silent = false) => {
      if (!silent) {
        setVolunteerSettlementLoading(true);
      }

      try {
        const body = {
          fromDate: String(payload?.fromDate || "").trim(),
          toDate: String(payload?.toDate || "").trim(),
        };

        if (!body.fromDate || !body.toDate) {
          if (!silent) {
            toast.error("From date and to date are required");
          }

          setVolunteerSettlements([]);
          setVolunteerSettlementDetails(null);

          return [];
        }

        if (body.fromDate > body.toDate) {
          if (!silent) {
            toast.error("From date cannot be greater than to date");
          }

          setVolunteerSettlements([]);
          setVolunteerSettlementDetails(null);

          return [];
        }

        const res = await api.post(
          "/api/VolunteerAdmin/v1.0/getVolunteerSettlementAmount",
          body,
        );

        console.log("Volunteer settlement API response:", res?.data);

        if (res?.data?.responseCode === "00") {
          const settlementResponse = res?.data?.response || null;

          const settlementList = Array.isArray(settlementResponse?.request)
            ? settlementResponse.request
            : [];

          setVolunteerSettlements(settlementList);
          setVolunteerSettlementDetails(settlementResponse);

          return settlementList;
        }

        setVolunteerSettlements([]);
        setVolunteerSettlementDetails(null);

        if (!silent) {
          toast.error(
            res?.data?.responseMessage ||
              "Failed to fetch volunteer settlement amount",
          );
        }

        return [];
      } catch (error) {
        console.error("fetchVolunteerSettlementAmount error:", error);
        console.error(
          "fetchVolunteerSettlementAmount response:",
          error?.response?.data,
        );

        setVolunteerSettlements([]);
        setVolunteerSettlementDetails(null);

        if (!silent) {
          toast.error(
            error?.response?.data?.responseMessage ||
              error?.message ||
              "Error fetching volunteer settlement amount",
          );
        }

        return [];
      } finally {
        if (!silent) {
          setVolunteerSettlementLoading(false);
        }
      }
    },
    [api],
  );

  return {
    volunteerSettlements,
    setVolunteerSettlements,

    volunteerSettlementDetails,
    setVolunteerSettlementDetails,

    volunteerSettlementLoading,

    fetchVolunteerSettlementAmount,
  };
}
